export default __webpack_public_path__ + "static/media/iconNotSelected.27f26006.svg";